import { env } from '../../app/env';
import { getTenantResourceService } from './tenantResource';

export async function getTenantTheme() {
  try {
    if (!env.TENANT_ID) {
      window.location.href = '/erro';
      return null;
    }
    const theme = await getTenantResourceService().getTheme();
    return theme ?? null;
  } catch (error) {
    console.error('Erro ao obter o tema do tenant:', error);
    return null;
  }
}
